import { useEffect, useRef, useState } from "react";

const useTextOverflow = () => {
  const [isOverflowed, setIsOverflowed] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const checkOverflow = () => {
      if (ref.current) {
        setIsOverflowed(ref.current.scrollHeight > ref.current.offsetHeight);
      }
    };

    checkOverflow();

    const resizeObserver = new ResizeObserver(checkOverflow);
    if (ref.current) {
      resizeObserver.observe(ref.current);
    }

    return () => resizeObserver.disconnect();
  }, []);

  return [ref, isOverflowed];
};

export default useTextOverflow;
